export const getDeliverableDetailViewUrl = (containerId: string): string => {
  return `/deliverables/${containerId}`;
};

export const getDeliverableFinalOutputReceiptsViewUrl = ({
  containerId,
  receiptId,
}: {
  containerId: string;
  receiptId: string;
}): string => {
  const deliverablesUrl = `${getDeliverableDetailViewUrl(
    containerId,
  )}/final-output-report-versions/${receiptId}`;

  return deliverablesUrl;
};
